import { useMemo } from 'react';

import { OrderResultClassification } from '@customTypes/order';

import { getVariantClassificationLabel } from '../../Results.utils';

interface IProps {
  classifications: OrderResultClassification[];
  isSingleGenePositive: boolean;
  clinicalSummary: string;
}

const ResultPane = ({ classifications, clinicalSummary, isSingleGenePositive }: IProps) => {
  const listOfResults: Array<{ label: string; value: string }[]> = useMemo(
    () =>
      isSingleGenePositive
        ? classifications.map(item => [
          {
            label: 'Gene',
            value: item.gene?.primary_symbol ?? item.location ?? '',
          },
          {
            label: 'Result',
            value: getVariantClassificationLabel(item.classification),
          },
          {
            label: 'Variant',
            value: item.variation?.display ?? '',
          },
          {
            label: 'Zygosity',
            value: item.zygosity,
          },
        ])
        : [],
    [classifications, isSingleGenePositive],
  );

  return (
    <div className='result-pane result-details-tab-content'>
      {isSingleGenePositive ? (
        listOfResults.map((results, index) => (
          <ul key={`result-panel-item-${index}`} className='d-flex flex-column gap-1 p-3 bg-white result-pane-item'>
            {results.map((result, resultIndex) => (
              <li className='result-pane-item-row' key={result.label}>
                <p className='fw-bold result-pane-item-label'>{result.label}</p>
                <p className={`result-pane-item-value ${resultIndex === 0 ? 'fst-italic' : ''}`}>{result.value}</p>
              </li>
            ))}
          </ul>
        ))
      ) : (
        <p className='px-2 pb-2 fw-bold'>{clinicalSummary}</p>
      )}
    </div>
  );
};
export default ResultPane;
